<template>
  <ValidationProvider
      tag="div" :class="inline && 'd-flex flex-row'"
      :name="labelText" :rules="getRules()"
      v-slot="{ errors }">
    <label v-if="!inline && !hideLabel" :for="getId()">{{ capitalize(labelText) }}</label>
    <input
        type="number" :class="getInputFieldClass()"
        :id="getId()" :placeholder="'Voer ' + labelText + ' in'"
        :min="minValue" :max="maxValue"
        :step="step"
        v-model.number="inputVal"/>

    <div v-if="inline" class="pl-3 col-lg-8">
      <span class="text-red">{{ errors[0] }}</span>
    </div>
    <span v-else class="text-red">{{ errors[0] }}</span>
  </ValidationProvider>
</template>

<script>
import {ValidationProvider} from "vee-validate";

export default {
  name: "NumberInputField",
  components: {
    ValidationProvider
  },
  props: {
    value: Number,
    hideLabel: Boolean,
    labelText: String,
    step: String,
    inline: Boolean,
    required: Boolean,
    minValue: String,
    maxValue: String,
    id: String,
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        if (val || val >= 0) {
          this.$emit('input', val);
        } else {
          this.$emit('input', undefined);
        }
      }
    }
  },
  methods: {
    getId() {
      return this.id || this.labelText;
    },
    capitalize(value) {
      if (!value) {
        return 0;
      }
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    },
    getRules() {
      const rules = [];

      if (this.required) {
        rules.push("required");
      }
      if (this.minValue) {
        rules.push("min_value:" + this.minValue);
      }
      if (this.maxValue) {
        rules.push("max_value:" + this.maxValue);
      }

      return rules.join('|');
    },
    getInputFieldClass() {
      return this.inline ? "form-control col-lg-4" : "form-control";
    }
  }
};
</script>

<style scoped>

.text-red {
  color: red;
}

</style>